'use es6';

import { Map as ImmutableMap } from 'immutable';
import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
const formatSettings = settings => ImmutableMap(settings).map((value, key) => ReferenceRecord({
  id: key,
  label: key,
  referencedObject: ImmutableMap({
    id: key,
    value
  })
}));
export default formatSettings;